import ApiService from '../../../../../../services/ApiService'
import GeneralService from '../../../../../../services/GeneralService'
import Utils from '../../../../../../Utils/FormatDate'
import EquipmentDowntimeInstitution from '../equipmentDowntimeInstitution/equipmentDowntime.vue'
import moment from 'moment'

export default {
  components: {
    EquipmentDowntimeInstitution,
  },

  async created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    const currentInstitutionId = JSON.parse(
      localStorage.getItem('institution')
    ).id
    this.institutionIds = [currentInstitutionId]

    // Aguardar carregar instituições primeiro
    await this.getInstitutions()

    if (this.institution.userType > 1) {
      this.getUserUnidades()
    } else {
      this.getUnidades()
    }

    this.getStandardEquipments()
    this.getDepartments()
    this.getWorkshops()

    this.filter.institutionIds = this.institutionIds

    if (this.institution.userType == 5) {
      this.unidadeIds = [this.userLogged.unidadeId]
    }

    this.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    this.setDates()

    // Permitir que o watcher funcione após a carga inicial
    this.$nextTick(() => {
      this.isInitialLoad = false
    })
  },

  data: () => ({
    departmentIds: [],
    localDepartments: [],
    departmentLoading: false,
    workshopSearch: '',
    unitySearch: '',
    institutionSearch: '',
    institution: {},
    loading: false,
    institutionLoading: false,
    unidadeLoading: false,
    standardEquipmentLoading: false,
    menuStartDate: false,
    menuEndDate: false,
    startDate: null,
    endDate: null,
    filterStartDate: null,
    filterEndDate: null,
    minDate: null,
    search: null,
    page: 1,
    pageSize: 7,
    standardEquipmentSelected: [],
    standardEquipments: [],
    institutionIds: [],
    institutions: [],
    unidadeIds: [],
    unidades: [],
    userLogged: {},
    isInitialLoad: true,
    causeDefects: [
      { text: 'Não aplicável', value: 0 },
      { text: 'Falha intrínseca', value: 1 },
      { text: 'Falha infraestrutura', value: 2 },
      { text: 'Erro operacional', value: 3 },
      { text: 'Dano acidental', value: 4 },
      { text: 'Abuso na utilização', value: 5 },
    ],
    workshopTypes: [],
    defectCauseSearch: null,
    filter: {
      page: 1,
      pageSize: 7,
      institutionIds: [],
      unidadeIds: [],
      defectCauses: [],
      workshops: [],
      standardEquipment: [],
      startDate: null,
      endDate: null,
    },
    apiService: new ApiService(),
    generalService: new GeneralService(),
  }),

  methods: {
    removeInstitution(item) {
      this.institutionIds.splice(item, 1)
      this.institutionIds = [...this.institutionIds]
    },
    removeCauseDefect(item) {
      this.filter.defectCauses.splice(item, 1)
      this.filter.defectCauses = [...this.filter.defectCauses]
    },
    removeWorkshop(item) {
      this.filter.workshops.splice(item, 1)
      this.filter.workshops = [...this.filter.workshops]
    },
    removeUnity(item) {
      this.unidadeIds.splice(item, 1)
      this.unidadeIds = [...this.unidadeIds]
    },
    removeDepartment(item) {
      this.departmentIds.splice(item, 1)
      this.departmentIds = [...this.departmentIds]
    },
    async getWorkshops() {
      this.workshopTypes = []

      if (this.institutionIds.length === 0) {
        return
      }

      const promises = this.institutionIds.map((institutionId) =>
        this.apiService
          .get('workshop/' + institutionId)
          .then((response) => {
            const institution = this.institutions.find(
              (inst) => inst.id === institutionId
            )
            return response.content.map((workshop) => ({
              ...workshop,
              institutionName: institution ? institution.name : '',
              displayName: `${workshop.name} / ${
                institution ? institution.name : ''
              }`,
            }))
          })
          .catch(() => [])
      )

      await Promise.all(promises).then((results) => {
        this.workshopTypes = results.flat()
      })
    },
    setDates() {
      this.filter.startDate = moment(this.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.filter.endDate = moment(this.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    },

    formatMonth(date) {
      return moment(date).locale(this.$i18n.locale).format('MMMM/YYYY')
    },

    async getUserUnidades() {
      this.unidadeLoading = true
      this.unidades = []

      if (this.institutionIds.length === 0) {
        this.unidadeLoading = false
        return
      }

      const promises = this.institutionIds.map((institutionId) =>
        this.apiService
          .get(`unidade/listByUserAndInstitution/${institutionId}`)
          .then((response) => {
            const institution = this.institutions.find(
              (inst) => inst.id === institutionId
            )
            return response.content.map((unidade) => ({
              ...unidade,
              institutionName: institution ? institution.name : '',
              displayName: `${unidade.name} / ${
                institution ? institution.name : ''
              }`,
            }))
          })
          .catch(() => [])
      )

      await Promise.all(promises).then((results) => {
        this.unidades = results.flat()
        this.unidadeLoading = false
      })
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService
        .get('institution/list')
        .then((response) => {
          this.institutions = response.content
          this.institutionLoading = false
        })
        .catch((err) => {})
    },

    async getUnidades() {
      this.unidadeLoading = true
      this.unidades = []

      if (this.institutionIds.length === 0) {
        this.unidadeLoading = false
        return
      }

      const promises = this.institutionIds.map((institutionId) =>
        this.apiService
          .get(`unidade/list/${institutionId}`)
          .then((response) => {
            const institution = this.institutions.find(
              (inst) => inst.id === institutionId
            )
            return response.content.map((unidade) => ({
              ...unidade,
              institutionName: institution ? institution.name : '',
              displayName: `${unidade.name} / ${
                institution ? institution.name : ''
              }`,
            }))
          })
          .catch(() => [])
      )

      await Promise.all(promises).then((results) => {
        this.unidades = results.flat()
        this.unidadeLoading = false
      })
    },

    async getStandardEquipments() {
      this.standardEquipmentLoading = true
      this.standardEquipments = []

      if (this.institutionIds.length === 0) {
        this.standardEquipmentLoading = false
        return
      }

      const promises = this.institutionIds.map((institutionId) =>
        this.generalService
          .getStandardEquipmentsByInstitution(institutionId)
          .then((equipments) => {
            const institution = this.institutions.find(
              (inst) => inst.id === institutionId
            )
            return equipments.map((equipment) => ({
              ...equipment,
              institutionName: institution ? institution.name : '',
              displayName: `${equipment.name} / ${
                institution ? institution.name : ''
              }`,
            }))
          })
          .catch(() => [])
      )

      await Promise.all(promises).then((results) => {
        this.standardEquipments = results.flat()
        this.standardEquipmentLoading = false
      })
    },

    removeStandardEquipment(item) {
      this.standardEquipmentSelected.splice(
        this.standardEquipmentSelected.indexOf(item),
        1
      )
      this.standardEquipmentSelected = [...this.standardEquipmentSelected]
    },
    async getDepartments() {
      this.departmentLoading = true
      this.localDepartments = []

      if (this.institutionIds.length === 0) {
        this.departmentLoading = false
        return
      }

      const promises = this.institutionIds.map((institutionId) =>
        this.apiService
          .get(`department/list/${institutionId}`)
          .then((response) => {
            const institution = this.institutions.find(
              (inst) => inst.id === institutionId
            )
            return response.content.map((department) => ({
              ...department,
              institutionName: institution ? institution.name : '',
              displayName: department.unidade
                ? `${department.name} / ${department.unidade.name} / ${
                    institution ? institution.name : ''
                  }`
                : `${department.name} / ${institution ? institution.name : ''}`,
            }))
          })
          .catch(() => [])
      )

      await Promise.all(promises).then((results) => {
        this.localDepartments = results.flat()
        this.departmentLoading = false
      })
    },

    filterTables() {
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.institutionIds = this.institutionIds
      this.filter.unidadeIds = this.unidadeIds
      this.filter.startDate = this.filterStartDate
      this.filter.endDate = this.filterEndDate
      this.filter.standardEquipment = this.standardEquipmentSelected
      this.filter.departmentIds = this.departmentIds

      this.setDates()

      this.$refs.downtimeInstitution.listDowntimes()
    },

    reset() {
      this.institutionIds = [this.institution.id]
      if (this.institution.userType == 5) {
        this.unidadeIds = [this.userLogged.unidadeId]
      } else {
        this.unidadeIds = []
      }
      this.standardEquipmentSelected = []
      this.departmentIds = []
      this.filter = {
        page: 1,
        pageSize: 7,
        institutionIds: [],
        unidadeIds: [],
        defectCauses: [],
        workshops: [],
        standardEquipment: [],
        departmentIds: [],
        startDate: null,
        endDate: null,
      }
      this.startDate = moment()
        .add(-1, 'month')
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.endDate = moment()
        .add(-1, 'month')
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')

      this.filterStartDate = null
      this.filterEndDate = null

      this.setDates()
      this.filterTables()
    },

    getFirstDayLastMonth(date) {
      return Utils.getFirstDayLastMonth(date)
    },

    getEndDayLastMonth(date) {
      return Utils.getEndDayLastMonth(date)
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.startDate = this.formatInputDate(this.filterStartDate)
      this.$refs.menuStartDate.save(date)
      this.minDate = new Date(this.filterStartDate).toISOString().substr(0, 10)
      this.endDate = this.formatInputDate(this.filterEndDate)
      this.$refs.menuEndDate.save(date)
    },
  },

  watch: {
    institutionIds: {
      handler(newVal, oldVal) {
        // Ignorar mudanças durante a carga inicial
        if (this.isInitialLoad) return

        if (
          JSON.stringify(newVal) !== JSON.stringify(oldVal) &&
          newVal.length > 0
        ) {
          // Limpar seleções quando instituições mudarem
          this.unidadeIds = []
          this.departmentIds = []
          this.filter.workshops = []
          this.standardEquipmentSelected = []

          // Recarregar dados
          if (this.institution.userType > 1) {
            this.getUserUnidades()
          } else {
            this.getUnidades()
          }
          this.getDepartments()
          this.getWorkshops()
          this.getStandardEquipments()
        }
      },
      deep: true,
    },
  },
}
